// extracted by mini-css-extract-plugin
export default {"placard-highlighter":"highlighter_placard-highlighter__Hbvo-","show":"highlighter_show__QcUqb","title":"highlighter_title__yoV1-"};